export const PAYMENT_STATUSES = {
  PENDING: 1,
  SUCCESS: 2,
  FAILURE: 3,
  CANCELLED: 4,
  REFUND: 5,
};

export const REFUND_STATUSES = {
  Requesting: 1,
  Requested: 2,
  Rejected: 3,
  Completed: 4,
  Failed: 5,
} as const;

export type RefundStatus = (typeof REFUND_STATUSES)[keyof typeof REFUND_STATUSES];

export const REFUND_STATUSES_LABELS: Record<RefundStatus, string> = {
  [REFUND_STATUSES.Requesting]: "W trakcie zlecania",
  [REFUND_STATUSES.Requested]: "Zlecony",
  [REFUND_STATUSES.Rejected]: "Odrzucony",
  [REFUND_STATUSES.Completed]: "Zrealizowany",
  [REFUND_STATUSES.Failed]: "Nieudany",
};
export const REGISTRATION_TRANCHE_PAYMENT_STATUSES = {
  NOT_PAID: 1,
  PENDING_PAYMENT: 2,
  PAID_BY_USER: 3,
  SKIPPED_BY_ADMIN: 4,
  PAYED_OUTSIDE_SYSTEM: 5,
} as const;

export type RegistrationTrancheStatus =
  (typeof REGISTRATION_TRANCHE_PAYMENT_STATUSES)[keyof typeof REGISTRATION_TRANCHE_PAYMENT_STATUSES];
export const REGISTRATION_TRANCHE_PAYMENT_STATUSES_LABELS = {
  [REGISTRATION_TRANCHE_PAYMENT_STATUSES.NOT_PAID]: "Nieopłacona",
  [REGISTRATION_TRANCHE_PAYMENT_STATUSES.PENDING_PAYMENT]: "Oczekuje",
  [REGISTRATION_TRANCHE_PAYMENT_STATUSES.PAID_BY_USER]: "Opłacona",
  [REGISTRATION_TRANCHE_PAYMENT_STATUSES.SKIPPED_BY_ADMIN]: "Pominięta",
  [REGISTRATION_TRANCHE_PAYMENT_STATUSES.PAYED_OUTSIDE_SYSTEM]:
    "Opłacona poza systemem",
} as const;

export const REGISTRATION_TRANCHE_PAYMENT_STATUSES_OPTIONS = Object.keys(
  REGISTRATION_TRANCHE_PAYMENT_STATUSES_LABELS
).map((key) => {
  const typedKey = +key as RegistrationTrancheStatus;
  return {
    value: typedKey,
    label: REGISTRATION_TRANCHE_PAYMENT_STATUSES_LABELS[typedKey],
  };
});

type PaymentStatus = (typeof PAYMENT_STATUSES)[keyof typeof PAYMENT_STATUSES];
export const PAYMENT_STATUSES_LABELS: Record<PaymentStatus, string> = {
  [PAYMENT_STATUSES.PENDING]: "Wygenerowano link do płatności",
  [PAYMENT_STATUSES.SUCCESS]: "Zaksięgowano płatność",
  [PAYMENT_STATUSES.FAILURE]: "Nieudana płatność",
  [PAYMENT_STATUSES.CANCELLED]: "Anulowano płatność",
  [PAYMENT_STATUSES.REFUND]: "Zwrot",
};
export const PAYMENT_STATUSES_COLORS: Record<PaymentStatus, string> = {
  [PAYMENT_STATUSES.PENDING]: "text-slate-500",
  [PAYMENT_STATUSES.SUCCESS]: "text-green-500",
  [PAYMENT_STATUSES.FAILURE]: "text-red-500",
  [PAYMENT_STATUSES.CANCELLED]: "text-red-500",
  [PAYMENT_STATUSES.REFUND]: "text-purple-600",
};
export const PAYMENT_STATUSES_ELEMENTS: Record<PaymentStatus, JSX.Element> = {
  [PAYMENT_STATUSES.PENDING]: (
    <span className="text-slate-500">
      {PAYMENT_STATUSES_LABELS[PAYMENT_STATUSES.PENDING]}
    </span>
  ),
  [PAYMENT_STATUSES.SUCCESS]: (
    <span className="text-green-500">
      {PAYMENT_STATUSES_LABELS[PAYMENT_STATUSES.SUCCESS]}
    </span>
  ),
  [PAYMENT_STATUSES.FAILURE]: (
    <span className="text-red-500">
      {PAYMENT_STATUSES_LABELS[PAYMENT_STATUSES.FAILURE]}
    </span>
  ),
  [PAYMENT_STATUSES.CANCELLED]: (
    <span className="text-orange-500">
      {PAYMENT_STATUSES_LABELS[PAYMENT_STATUSES.CANCELLED]}
    </span>
  ),
  [PAYMENT_STATUSES.REFUND]: (
    <span className="text-purple-600">
      {PAYMENT_STATUSES_LABELS[PAYMENT_STATUSES.REFUND]}
    </span>
  ),
};

export const PAYMENT_STATUSES_OPTIONS = Object.keys(
  PAYMENT_STATUSES_LABELS
).map((key) => ({
  value: +key,
  label: PAYMENT_STATUSES_LABELS[+key],
}));

export const COURSE_EXAM_PAYMENT_STATUS = {
  Free: 1,
  Paid: 2,
  NotPaid: 3,
  PaymentInProgress: 4,
  PaymentFailed: 5,
  CancelledByAdministrator: 6,
} as const;

export type CourseExamPaymentStatus =
  (typeof COURSE_EXAM_PAYMENT_STATUS)[keyof typeof COURSE_EXAM_PAYMENT_STATUS];

export const COURSE_EXAM_PAYMENT_STATUSES_LABELS = {
  [COURSE_EXAM_PAYMENT_STATUS.Free]: "Darmowy",
  [COURSE_EXAM_PAYMENT_STATUS.Paid]: "Opłacony",
  [COURSE_EXAM_PAYMENT_STATUS.NotPaid]: "Nieopłacony",
  [COURSE_EXAM_PAYMENT_STATUS.PaymentInProgress]: "Trwa płatność",
  [COURSE_EXAM_PAYMENT_STATUS.PaymentFailed]: "Nieudana płatność",
  [COURSE_EXAM_PAYMENT_STATUS.CancelledByAdministrator]:
    "Anulowana przez administratora",
};

export const INVOICE_TYPE = {
  ADVANCED_PAYMENT: 1,
  STANDARD: 2,
  FINAL_PAYMENT: 3,
} as const;

export type InvoiceType = (typeof INVOICE_TYPE)[keyof typeof INVOICE_TYPE];

export const INVOICE_TYPE_LABELS: Record<InvoiceType, string> = {
  [INVOICE_TYPE.ADVANCED_PAYMENT]: "Zaliczkowa",
  [INVOICE_TYPE.STANDARD]: "Standardowa",
  [INVOICE_TYPE.FINAL_PAYMENT]: "Końcowa",
};

export const INVOICE_TYPE_OPTIONS = Object.keys(INVOICE_TYPE_LABELS).map(
  (key) => ({
    value: +key,
    label: INVOICE_TYPE_LABELS[+key as InvoiceType],
  })
);
